import React from 'react'
import PropTypes from 'prop-types'
import { observable, toJS, autorun } from 'mobx'
import ModelContext from './contexts/ModelContext'
import useModel from './hooks/use-model'
import useOnOperationData from './hooks/use-on-operation-data'

function ModelProxyPayload (props) {
  const parentModel = useModel()

  const modelRef = React.useRef(observable.map())
  const model = modelRef.current

  function loadData (data) {
    if (typeof data.model !== 'undefined') {
      model.replace(data.model)
    } else {
      model.clear()
    }
  }

  function loadDataFromProxy () {
    if (parentModel) {
      const data = {
        model: {}
      }

      let newData = props.proxyFrom !== null
        ? parentModel.get(props.proxyFrom)
        : parentModel

      if (!newData.get || typeof newData.get !== 'function') {
        newData = observable.map(Object.entries(toJS(newData)))
      }

      newData.forEach((v, k) => {
        data.model[k] = v
      })

      loadData(data)
    }
  }

  React.useEffect(() => {
    const disposer = autorun(() => {
      loadDataFromProxy()
    }, { fireImmediately: true })

    return () => {
      disposer()
    }
  }, [parentModel])

  useOnOperationData(data => {
    loadData(data)
  })

  return (
    <ModelContext.Provider value={model}>
      <>
        {props.children}
      </>
    </ModelContext.Provider>
  )
}

ModelProxyPayload.defaultProps = {
  proxyFrom: null
}

ModelProxyPayload.propTypes = {
  proxyFrom: PropTypes.any
}

export default ModelProxyPayload
